// extracted by mini-css-extract-plugin
export default {"root":"BroadcastRoomContainer_root__PXY4P","room":"BroadcastRoomContainer_room__5l9Fp"};